<template>
  <div class="tw:mx-4 tw:lg:mx-0">
    <div class="tw:my-4">
      <ProfileInformation :user="userDetails" :loading="isUserDetailsLoading" />
    </div>
  </div>
</template>

<script setup lang="ts">
import ProfileInformation from '@/components/settings/profileSettings/ProfileInformation.vue'

import { useUserDetails } from '@/layouts/queries'
import { useSessionValues } from '@/composables/useSessionValues'

const { userId } = useSessionValues()
const { userDetails, isUserDetailsLoading } = useUserDetails(userId)
</script>
